import { useCanViewEmails } from '../../../helpers/useCanViewEmails';
import React, { useEffect, useRef, useState } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Tooltip } from '@material-ui/core';
import cx from 'classnames';

import AlreadySuperAdminIcon from '../../../assets/icons/alreadySuperAdmin.svg';
import SetSuperAdminIcon from '../../../assets/icons/setSuperAdmin.svg';
import DeleteUserSuperAdminModal from './DeleteUserSuperAdminModal';
import GroupIcon from '../../../assets/icons/new-group-icon.svg';
import MyGroupIcon from '../../../assets/icons/folder-open.svg';
import DeleteUserModal from './DeleteUserModal/DeleteUserModal';
import { DateFormatter } from '../../../helpers/dateFormatter';
import BellIcon from '../../../assets/icons/bell-button.svg';
import { displayRole, useDimensions } from '../../../helpers';
import { removeFinishPreviewUserId, setPreviewAccessToken } from '../../../helpers';
import { ROLES, RolesLowerCase } from '../../../enums/ROLES';
import RevokeSuperAdminModal from './RevokeSuperAdminModal';
import { SortFields, SortType } from '../../../enums/SORT';
import EditIcon from '../../../assets/icons/edit-pen.svg';
import EditUserModal from './EditUserModal/EditUserModal';
import TrashIcon from '../../../assets/icons/trash.svg';
import headerStyles from './UserListHeader.module.scss';
import { useAppSelector } from '../../../store/hooks';
import SetSuperAdminModal from './SetSuperAdminModal';

import styles from './Users.module.scss';
import RolePlate from '../RolePlate';
import { ReactComponent as EyeIcon } from '../../../assets/icons/eye.svg';
import Avatar from '../Avatar';
import { PATHS, USER } from '../../../enums';
import { useHistory } from 'react-router-dom';
import { getUserOrganization, getUserPreviewToken, postUserHelpResponse } from '../../../api';
import { useDispatch } from 'react-redux';
import { saveMyOrganization } from '../../../store/user/userSlice';
import StartPreviewModal from './StartPreviewModal';

import { useSnackbar } from 'material-ui-snackbar-provider';
import useOnClickOutside from '../../../helpers/useOnClickOutside';

import { MoreIcon } from '../../../assets/icons/threedots';
import ApplyPreferencesModal from '../ApplyPreferencesModal';

type TOrganizationUsersHeader = {
  sortByType: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  sortField: SortFields;
  sortType: SortType;
  selectMode?: boolean;
};

export const OrganizationUsersHeader: React.FC<TOrganizationUsersHeader> = ({ sortByType, sortField, sortType, selectMode }) => {
  const canViewEmails = useCanViewEmails();
  const { widthD } = useDimensions();
  const userRole = useAppSelector((state) => state.user.role);

  return (
    <div className={headerStyles.container}>
      <div className={headerStyles.header}>
        <div className={headerStyles.name}>
          <button type="button" name={SortFields.NAME} onClick={sortByType} className={headerStyles.btn}>
            Name
            {sortType === SortType.DESC && sortField === SortFields.NAME ? (
              <KeyboardArrowUpIcon name={SortFields.NAME} />
            ) : (
              <KeyboardArrowDownIcon name={SortFields.NAME} />
            )}
          </button>
        </div>
        {canViewEmails && (<div className={headerStyles.email}>
          <button type="button" name={SortFields.EMAIL} onClick={sortByType} className={headerStyles.btn}>
            Email
            {sortType === SortType.DESC && sortField === SortFields.EMAIL ? (
              <KeyboardArrowUpIcon name={SortFields.EMAIL} />
            ) : (
              <KeyboardArrowDownIcon name={SortFields.EMAIL} />
            )}
          </button>
        </div>)}
        <div className={headerStyles.role}>
          <button type="button" name={SortFields.ROLE} onClick={sortByType} className={headerStyles.btn}>
            Role
            {sortType === SortType.DESC && sortField === SortFields.ROLE ? (
              <KeyboardArrowUpIcon name={SortFields.ROLE} />
            ) : (
              <KeyboardArrowDownIcon name={SortFields.ROLE} />
            )}
          </button>
        </div>
        <div className={headerStyles.groups}>
          <button type="button" name={SortFields.ORGANIZATION_NAME} className={headerStyles.btn}>
            {userRole && userRole === ROLES.SUPER_ADMIN ? (widthD < 1200 ? 'Orgs' : 'Organisations') : 'Groups'}
          </button>
        </div>
        <div className={headerStyles.date}>
          <button className={headerStyles.btn} type="button" onClick={sortByType} name={SortFields.LAST_LOGIN}>
            {widthD < 1200 ? 'Online' : 'Last Active'}
            {sortType === SortType.DESC && sortField === SortFields.LAST_LOGIN ? (
              <KeyboardArrowUpIcon name={SortFields.LAST_LOGIN} />
            ) : (
              <KeyboardArrowDownIcon name={SortFields.LAST_LOGIN} />
            )}
          </button>
        </div>

        <div className={headerStyles.joinDate}> {widthD < 1200 ? 'Joined' : 'Join Date'}</div>
        <div className={headerStyles.actionBtns}>{!selectMode && 'Action'}</div>
      </div>
    </div>
  );
};

export const OrganizationUser = ({
  user,
  fetchData,
  selectMode,
  toRenotifyUserModal,
}: {
  user: any;
  fetchData: () => Promise<unknown>;
  selectMode?: boolean;
  toRenotifyUserModal: (val: USER[] | 'all' | null) => void;
}) => {
  const canViewEmails = useCanViewEmails();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const { currentUser, role } = useAppSelector((state) => state.user);
  const { widthD } = useDimensions();
  const [showSuperAdminModal, setShowSuperAdminModal] = useState(false);

  const [showDeleteUserSuperAdminModal, setDeleteUserSuperAdminModal] = useState(false);

  const rowRef = useRef<HTMLDivElement | null>(null);
  const actionMenuRef = useRef<HTMLDivElement | null>(null);
  const [showDotsMenu, setShowDotsMenu] = useState(false);
  const [menuPosition, setMenuPosition] = useState({ x: 0, y: 0 });
  const [showUserPreferencesModal, setShowUserPreferencesModal] = useState(false);

  useOnClickOutside(actionMenuRef, () => {
    setShowDotsMenu(false);
  });

  const selectUserToRenotify = () => {
    if (isSentRecently) return;
    toRenotifyUserModal([user]);
  };

  const switchSuperAdminModal = () => {
    setShowSuperAdminModal(!showSuperAdminModal);
  };

  const switchDeleteModal = () => {
    setShowDeleteModal(!showDeleteModal);
  };

  const switchEditModal = () => {
    setShowEditModal(!showEditModal);
  };

  const switchSuperAdminDelete = () => {
    setDeleteUserSuperAdminModal(!showDeleteUserSuperAdminModal);
  };

  // 24 hours
  const isSentRecently = user?.resend_email_date
    ? new Date().getTime() - new Date(user?.resend_email_date).getTime() < 24 * 60 * 60 * 1000
    : false;

  const hoursAgo = user?.resend_email_date
    ? Math.floor((new Date().getTime() - new Date(user?.resend_email_date).getTime()) / (60 * 60 * 1000))
    : null;

  const [lastOnline, setLastOnline] = useState<string>('None');
  useEffect(() => {
    if (user?.last_online) {
      const hoursAgo = user?.last_online
        ? Math.floor((new Date().getTime() - new Date(user?.last_online).getTime()) / (60 * 60 * 1000))
        : null;

      if (hoursAgo === 0) {
        setLastOnline(`<1h ago`);
      } else if (hoursAgo && hoursAgo < 12) {
        setLastOnline(`${hoursAgo}h ago`);
      } else {
        setLastOnline(DateFormatter(user.last_online));
      }
    }
  }, [user?.last_online]);

  const switchDotsMenu = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();

    if (showDotsMenu) {
      setShowDotsMenu(false);
      return;
    }

    const rowElement = (e.currentTarget.closest(`.${styles.user}`) as HTMLElement) || rowRef.current;
    if (!rowElement) return;

    const rowRect = rowElement.getBoundingClientRect();
    const menuWidth = actionMenuRef.current?.offsetWidth || 250;
    const menuHeight = actionMenuRef.current?.offsetHeight || 290;

    let posX = e.clientX - rowRect.left;
    let posY = e.clientY - rowRect.top;

    // horizontal clamp: keep menu inside user row
    if (posX + menuWidth > rowRect.width) {
      posX = rowRect.width - menuWidth - 10;
    }
    if (posX < 0) {
      posX = 0;
    }

    const p = rowRect.bottom + menuHeight - window.innerHeight;
    // vertical clamp vs viewport bottom (same style as ComposerFolder)
    if (rowRect.bottom + menuHeight > window.innerHeight) {
      if (p > 90) {
        posY -= menuHeight - 100;
      }
    }

    setMenuPosition({
      x: posX + 20,
      y: posY,
    });

    setShowDotsMenu(true);
  };

  return (
    <div className={styles.container} style={{ position: 'relative' }} onContextMenu={switchDotsMenu}>
      <div className={styles.user} ref={rowRef}>
        <div className={styles.leftSide}>
          <Avatar avatar={user.avatar_url} name={user?.username || user?.role.title.replace('Organization', 'Organisation')} />
          <Tooltip title={user?.username ?? user?.role.title.replace('Organization', 'Organisation')}>
            <div className={styles.name}>{user?.username ?? user?.role.title.replace('Organization', 'Organisation')}</div>
          </Tooltip>
        </div>
        {canViewEmails && (<Tooltip title={user.email}>
          <div className={styles.email}>{user.email}</div>
        </Tooltip>)}
        <div className={styles.role}>
          <div className={!user.invitation_token ? styles.active : styles.notActive}>
            {currentUser?.role.title === RolesLowerCase.SUPER_ADMIN &&
              user.role.title === RolesLowerCase.SUPER_ADMIN &&
              user.organization_users?.length === 1 && (
                <div>
                  <Tooltip
                    arrow
                    placement="right"
                    title={
                      <div>
                        <div> Roles: </div>
                        {user.organization_users.map((u: any) => (
                          <div key={u.id} className={styles.roleTooltip}>
                            <div className={styles.orgTooltip}>{u?.organization?.name}</div> - {displayRole(u?.role?.title)}
                          </div>
                        ))}
                      </div>
                    }
                  >
                    <div className={styles.roleCount}> +{user.organization_users.length} </div>
                  </Tooltip>
                  <RolePlate userRole={user.role.title === RolesLowerCase.ORGANIZATION_ADMIN ? 'OA' : user.role.title} />
                </div>
              )}

            {currentUser?.role.title === RolesLowerCase.SUPER_ADMIN && user.organization_users?.length === 0 && (
              <div>
                <RolePlate userRole={user.role.title === RolesLowerCase.ORGANIZATION_ADMIN ? 'OA' : user.role.title} />
              </div>
            )}

            {currentUser?.role.title === RolesLowerCase.SUPER_ADMIN &&
              user.role.title !== RolesLowerCase.SUPER_ADMIN &&
              user.organization_users?.length === 1 && (
                <div>
                  <RolePlate userRole={user.role.title === RolesLowerCase.ORGANIZATION_ADMIN ? 'OA' : user.role.title} />
                </div>
              )}

            {currentUser?.role.title === RolesLowerCase.SUPER_ADMIN && user.organization_users && user.organization_users?.length > 1 && (
              <div>
                <Tooltip
                  arrow
                  placement="right"
                  title={
                    <div>
                      <div> Roles: </div>
                      {user.organization_users.map((u: any) => (
                        <div key={u.id} className={styles.roleTooltip}>
                          <div className={styles.orgTooltip}>{u?.organization?.name}</div> - {displayRole(u?.role?.title)}
                        </div>
                      ))}
                    </div>
                  }
                >
                  <div className={styles.roleCount}> +{user.organization_users.length} </div>
                </Tooltip>
                <RolePlate userRole={user.role.title === RolesLowerCase.ORGANIZATION_ADMIN ? 'OA' : user.role.title} />
              </div>
            )}

            {currentUser?.role.title !== RolesLowerCase.SUPER_ADMIN && (
              <RolePlate userRole={user.role.title === RolesLowerCase.ORGANIZATION_ADMIN ? 'OA' : user.role.title} />
            )}
          </div>
        </div>
        <div className={styles.groups} style={{ display: 'flex', alignItems: 'center' }}>
          {role && role === ROLES.SUPER_ADMIN ? (
            <Tooltip
              title={
                user.organization_users.length > 0 ? (
                  <div>
                    {user.organization_users &&
                      user.organization_users.map((u: any) => (
                        <div key={u.id} className={styles.roleTooltip}>
                          {' '}
                          <div className={styles.orgTooltip}>{u?.organization?.name} </div> - {displayRole(u?.role?.title)}{' '}
                        </div>
                      ))}
                  </div>
                ) : (
                  ''
                )
              }
            >
              <div className={styles.orgListTooltip}>
                <img src={MyGroupIcon} alt="group" /> {user.organization_users?.length}
              </div>
            </Tooltip>
          ) : (
            <Tooltip
              placement="right"
              arrow
              title={
                <div>
                  {' '}
                  {user.groups.map((group: any) => (
                    <div key={`${group.id}_tooltip`} style={{ display: 'flex', justifyContent: 'space-between' }}>
                      {' '}
                      <span style={{ marginRight: '8px' }}>{group.title} </span>
                    </div>
                  ))}{' '}
                </div>
              }
            >
              <div style={{ display: 'flex' }}>
                <img src={MyGroupIcon} alt="groups" style={{ marginRight: '4px', height: '16px' }} />
                {user.groups.length}
              </div>
            </Tooltip>
          )}
        </div>
        <div className={styles.date}>{lastOnline}</div>
        <div className={styles.joinDate}>
          {widthD < 1200 ? DateFormatter(user.created_at as string) : DateFormatter(user.created_at as string, true)}{' '}
        </div>

        {!selectMode && (
          <div className={styles.actionBtns}>
            <div className={styles.dotsMenuBtn} onClick={switchDotsMenu}>
              <div className={styles.dotIcon}>
                <MoreIcon />
              </div>
            </div>
          </div>
        )}
      </div>

      {!selectMode && (
        <div
          ref={actionMenuRef}
          className={styles.actionMenu}
          onClick={(e) => e.stopPropagation()}
          style={{
            position: 'absolute',
            display: showDotsMenu ? 'block' : 'none',
            top: `${menuPosition.y}px`,
            left: `${menuPosition.x}px`,
          }}
        >
          {role === ROLES.SUPER_ADMIN && (
            <div
              className={styles.menuOption}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setShowDotsMenu(false);
                if (user.role.title === RolesLowerCase.SUPER_ADMIN) {
                  switchDeleteModal();
                } else {
                  switchSuperAdminModal();
                }
              }}
            >
              {user.role.title === RolesLowerCase.SUPER_ADMIN ? (
                <>
                  <img src={AlreadySuperAdminIcon} alt="remove super admin" />
                  <span>Remove Super Admin</span>
                </>
              ) : (
                <>
                  <img src={SetSuperAdminIcon} alt="set super admin" />
                  <span>Set Super Admin</span>
                </>
              )}
            </div>
          )}

          {user?.invitation_token && (
            <div
              className={styles.menuOption}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setShowDotsMenu(false);
                selectUserToRenotify();
              }}
            >
              <img className={cx(isSentRecently && styles.disableRenotify)} src={BellIcon} alt="resend" />
              <span>{isSentRecently ? `Resend available in ${24 - (hoursAgo ?? 0)}h` : 'Resend registration link'}</span>
            </div>
          )}

          <div
            className={styles.menuOption}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setShowDotsMenu(false);
              switchEditModal();
            }}
          >
            <img src={EditIcon} alt="edit" />
            <span>Edit user</span>
          </div>
          {role === ROLES.ORGANIZATION_ADMIN && (
            <div
              className={styles.menuOption}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setShowDotsMenu(false);
                setShowUserPreferencesModal(true);
              }}
            >
              <img src={EditIcon} alt="preferences" />
              <span>User Preferences</span>
            </div>
          )}

          {currentUser?.id !== user.id && (
            <div
              className={styles.menuOption}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setShowDotsMenu(false);
                switchDeleteModal();
              }}
            >
              <img src={TrashIcon} alt="delete" />
              <span>Delete user</span>
            </div>
          )}
        </div>
      )}

      <DeleteUserModal fetchData={fetchData} switchModal={switchDeleteModal} isOpen={showDeleteModal} user={user} />
      {showDeleteUserSuperAdminModal && (
        <DeleteUserSuperAdminModal
          isOpen={showDeleteUserSuperAdminModal}
          switchModal={switchSuperAdminDelete}
          user={user}
          fetchData={fetchData}
        />
      )}
      <EditUserModal fetchData={fetchData} switchModal={switchEditModal} isOpen={showEditModal} user={user} />
      <ApplyPreferencesModal
        open={showUserPreferencesModal}
        onClose={() => setShowUserPreferencesModal(false)}
        title={`${user?.username || (canViewEmails ? user?.email : 'User')} Preferences`}
        fixedScope="user"
        fixedUserId={Number(user.id)}
      />
    </div>
  );
};

export const SAOrganizationUser = ({
  user,
  fetchData,
  selectMode,
  toRenotifyUserModal,
}: {
  user: USER;
  fetchData: () => Promise<unknown>;
  selectMode?: boolean;
  toRenotifyUserModal: (val: USER[] | 'all' | null) => void;
}) => {
  const canViewEmails = useCanViewEmails();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showStartPreviewModal, setShowStartPreviewModal] = useState(false);
  const { currentUser, role } = useAppSelector((state) => state.user);
  const [showQuickFinishPreviewModal, setShowQuickFinishPreviewModal] = useState(false);

  const { widthD } = useDimensions();
  const history = useHistory();
  const dispatch = useDispatch();
  const [showSuperAdminModal, setShowSuperAdminModal] = useState(false);

  const actionMenuRef = useRef<HTMLDivElement | null>(null);
  const [showDotsMenu, setShowDotsMenu] = useState(false);
  const [menuPosition, setMenuPosition] = useState({ x: 0, y: 0 });

  useOnClickOutside(actionMenuRef, (e) => {
    e.stopPropagation();
    setShowDotsMenu(false);
  });

  const switchSuperAdminModal = () => {
    setShowSuperAdminModal(!showSuperAdminModal);
  };

  const [showDeleteUserSuperAdminModal, setDeleteUserSuperAdminModal] = useState(false);
  const switchSuperAdminDelete = () => {
    setDeleteUserSuperAdminModal(!showDeleteUserSuperAdminModal);
  };

  const switchDeleteModal = () => {
    switchSuperAdminDelete();
  };

  const switchEditModal = () => {
    setShowEditModal(!showEditModal);
  };

  const switchStartPreviewModal = () => {
    setShowStartPreviewModal(!showStartPreviewModal);
  };

  const handleQuickResolvedIssue = async () => {
    try {
      await postUserHelpResponse({ userId: +user.id, instantFinish: true });
    } catch (error) {
      console.error(error);
    }
    setShowQuickFinishPreviewModal(!showQuickFinishPreviewModal);
    removeFinishPreviewUserId();
    fetchData();
  };

  const fetchOrganization = async () => {
    try {
      const { data } = await getUserOrganization();
      dispatch(saveMyOrganization(data));
    } catch (err) {
      console.log(`Error: `, err);
    }
  };

  const notification = useSnackbar();

  const handlePreview = async () => {
    try {
      const { data } = await getUserPreviewToken(user.id);

      setPreviewAccessToken(data.accessToken);

      fetchOrganization();

      history.push(encodeURI(`${PATHS.USERS_LIST.path}`));
      window.location.reload();
    } catch (err) {
      console.log(err);
      // @ts-ignore
      if (err?.response?.data?.message) {
        // @ts-ignore
        notification.showMessage(err.response.data.message);
      }
      switchStartPreviewModal();
      await fetchData();
    }
  };

  // 24 hours
  const isSentRecently = user?.resend_email_date
    ? new Date().getTime() - new Date(user?.resend_email_date).getTime() < 24 * 60 * 60 * 1000
    : false;

  const hoursAgo = user?.resend_email_date
    ? Math.floor((new Date().getTime() - new Date(user?.resend_email_date).getTime()) / (60 * 60 * 1000))
    : null;

  const selectUserToRenotify = () => {
    if (isSentRecently) return;
    toRenotifyUserModal([user]);
  };

  const [lastOnline, setLastOnline] = useState<string>('None');
  useEffect(() => {
    const lastOnline = user?.last_online || user?.last_login;

    if (lastOnline) {
      const hoursAgo = lastOnline ? Math.floor((new Date().getTime() - new Date(lastOnline).getTime()) / (60 * 60 * 1000)) : null;
      if (hoursAgo === 0) {
        setLastOnline(`<1h ago`);
      } else if (hoursAgo && hoursAgo < 12) {
        setLastOnline(`${hoursAgo}h ago`);
      } else {
        setLastOnline(DateFormatter(lastOnline));
      }
    }
  }, [user?.last_online, user?.last_login]);

  const switchDotsMenu = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();

    if (showDotsMenu) {
      setShowDotsMenu(false);
      return;
    }

    const userElement = e.currentTarget.closest(`.${styles.user}`) as HTMLElement;
    if (!userElement) return;

    const userRect = userElement.getBoundingClientRect();
    const menuWidth = actionMenuRef.current?.offsetWidth || 200;
    const menuHeight = actionMenuRef.current?.offsetHeight || 290;

    let posX = e.clientX - userRect.left;
    let posY = e.clientY - userRect.top;

    // horizontal clamp: keep inside user row
    if (posX + menuWidth > userRect.width) {
      posX = userRect.width - menuWidth - 10;
    }
    if (posX < 0) {
      posX = 0;
    }

    const p = userRect.bottom + menuHeight - window.innerHeight;
    // vertical clamp vs viewport bottom (same style as ComposerFolder)
    if (userRect.bottom + menuHeight > window.innerHeight) {
      if (p > 90) {
        posY -= menuHeight - 100;
      }
    }

    setMenuPosition({
      x: posX,
      y: posY,
    });

    setShowDotsMenu(true);
  };

  return (
    <div className={styles.container} style={{ position: 'relative' }}>
      <div className={styles.user} onContextMenu={switchDotsMenu}>
        <div className={styles.leftSide}>
          <Avatar avatar={user.avatar_url} name={user?.username || user?.role.title.replace('Organization', 'Organisation')} />
          <Tooltip title={user?.username ?? user?.role.title.replace('Organization', 'Organisation')}>
            <div className={styles.name}>{user?.username ?? user?.role.title.replace('Organization', 'Organisation')}</div>
          </Tooltip>
          {user.need_help && currentUser?.email !== user.email && (
            <Tooltip arrow placement="top" title={`User requested help: ${user.need_help}`}>
              <div onClick={switchStartPreviewModal}>
                <EyeIcon className={styles.previewEye} />
              </div>
            </Tooltip>
          )}
        </div>
        {canViewEmails && (<Tooltip title={user.email}>
          <div className={styles.email}>{user.email}</div>
        </Tooltip>)}
        <div className={styles.role}>
          <div className={!user.invitation_token ? styles.active : styles.notActive}>
            {currentUser?.role.title === RolesLowerCase.SUPER_ADMIN &&
              user.role.title === RolesLowerCase.SUPER_ADMIN &&
              user.organization_users?.length === 1 && (
                <div>
                  <Tooltip
                    arrow
                    placement="right"
                    title={
                      <div>
                        <div> Roles: </div>
                        {user.organization_users.map((u: any) => (
                          <div key={u.id} className={styles.roleTooltip}>
                            <div className={styles.orgTooltip}>{u?.organization?.name}</div> - {displayRole(u?.role?.title)}
                          </div>
                        ))}
                      </div>
                    }
                  >
                    <div className={styles.roleCount}> +{user.organization_users.length} </div>
                  </Tooltip>
                  <RolePlate userRole={user.role.title} />
                </div>
              )}

            {currentUser?.role.title === RolesLowerCase.SUPER_ADMIN && user.organization_users?.length === 0 && (
              <div>
                <RolePlate userRole={user.role.title === RolesLowerCase.ORGANIZATION_ADMIN ? 'OA' : user.role.title} />
              </div>
            )}

            {currentUser?.role.title === RolesLowerCase.SUPER_ADMIN &&
              user.role.title !== RolesLowerCase.SUPER_ADMIN &&
              user.organization_users?.length === 1 && (
                <div>
                  <RolePlate userRole={user.role.title === RolesLowerCase.ORGANIZATION_ADMIN ? 'OA' : user.role.title} />
                </div>
              )}

            {currentUser?.role.title === RolesLowerCase.SUPER_ADMIN && user.organization_users && user.organization_users?.length > 1 && (
              <div>
                <Tooltip
                  arrow
                  placement="right"
                  title={
                    <div>
                      <div> Roles: </div>
                      {user.organization_users.map((u: any) => (
                        <div key={u.id} className={styles.roleTooltip}>
                          <div className={styles.orgTooltip}>{u?.organization?.name}</div> - {displayRole(u?.role?.title)}
                        </div>
                      ))}
                    </div>
                  }
                >
                  <div className={styles.roleCount}> +{user.organization_users.length} </div>
                </Tooltip>
                <RolePlate userRole={user.role.title === RolesLowerCase.ORGANIZATION_ADMIN ? 'OA' : user.role.title} />
              </div>
            )}

            {currentUser?.role.title !== RolesLowerCase.SUPER_ADMIN && (
              <RolePlate userRole={user.role.title === RolesLowerCase.ORGANIZATION_ADMIN ? 'OA' : user.role.title} />
            )}
          </div>
        </div>
        <div className={styles.groups} style={{ display: 'flex', alignItems: 'center' }}>
          {role && role === ROLES.SUPER_ADMIN ? (
            <Tooltip
              title={
                user?.organization_users && user?.organization_users?.length > 0 ? (
                  <div>
                    {user.organization_users &&
                      user.organization_users.map((u: any) => (
                        <div key={u.id} className={styles.roleTooltip}>
                          {' '}
                          <div className={styles.orgTooltip}>{u?.organization?.name} </div> - {displayRole(u?.role?.title)}{' '}
                        </div>
                      ))}
                  </div>
                ) : (
                  ''
                )
              }
            >
              <div className={styles.orgListTooltip}>
                <img src={MyGroupIcon} alt="group" /> {user.organization_users?.length}
              </div>
            </Tooltip>
          ) : (
            <>
              <img src={MyGroupIcon} alt="folders" style={{ marginRight: '4px', height: '16px' }} /> 1
              <img src={GroupIcon} alt="group" style={{ marginLeft: '8px', marginRight: '4px' }} /> 1
            </>
          )}
        </div>
        <div className={styles.date}>{lastOnline}</div>
        <div className={styles.joinDate}>
          {widthD < 1530 ? DateFormatter(user.created_at as string) : DateFormatter(user.created_at as string, true)}{' '}
        </div>
        {!selectMode && (
          <div className={styles.actionBtns}>
            <div className={styles.dotsMenuBtn} onClick={switchDotsMenu}>
              <div className={styles.dotIcon}>
                <MoreIcon />
              </div>
            </div>
          </div>
        )}
      </div>

      {!selectMode && (
        <div
          ref={actionMenuRef}
          className={styles.actionMenu}
          onClick={(e) => e.stopPropagation()}
          style={{
            position: 'absolute',
            display: showDotsMenu ? 'block' : 'none',
            top: `${menuPosition.y}px`,
            left: `${menuPosition.x}px`,
          }}
        >
          {user?.invitation_token && (
            <div
              className={styles.menuOption}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setShowDotsMenu(false);
                selectUserToRenotify();
              }}
            >
              <img className={cx(isSentRecently && styles.disableRenotify)} src={BellIcon} alt="resend" />
              <span>{isSentRecently ? `Resend available in ${24 - (hoursAgo ?? 0)}h` : 'Resend registration link'}</span>
            </div>
          )}

          {role === ROLES.SUPER_ADMIN && (
            <div
              className={styles.menuOption}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setShowDotsMenu(false);
                if (user.role.title === RolesLowerCase.SUPER_ADMIN) {
                  switchDeleteModal();
                } else {
                  switchSuperAdminModal();
                }
              }}
            >
              {user.role.title === RolesLowerCase.SUPER_ADMIN ? (
                <>
                  <img src={AlreadySuperAdminIcon} alt="remove super admin" />
                  <span>Remove Super Admin</span>
                </>
              ) : (
                <>
                  <img src={SetSuperAdminIcon} alt="set super admin" />
                  <span>Set Super Admin</span>
                </>
              )}
            </div>
          )}

          <div
            className={styles.menuOption}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setShowDotsMenu(false);
              switchEditModal();
            }}
          >
            <img src={EditIcon} alt="edit" />
            <span>Edit user</span>
          </div>

          {currentUser?.id !== user.id && (
            <div
              className={styles.menuOption}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setShowDotsMenu(false);
                switchDeleteModal();
              }}
            >
              <img src={TrashIcon} alt="delete" />
              <span>Delete user</span>
            </div>
          )}
        </div>
      )}

      {user.role.title === RolesLowerCase.SUPER_ADMIN ? (
        <>
          <RevokeSuperAdminModal fetchData={fetchData} switchModal={switchDeleteModal} isOpen={showDeleteModal} user={user} />
        </>
      ) : (
        <>
          <SetSuperAdminModal fetchData={fetchData} switchModal={switchSuperAdminModal} isOpen={showSuperAdminModal} user={user} />
          <DeleteUserModal fetchData={fetchData} switchModal={switchDeleteModal} isOpen={showDeleteModal} user={user} />
        </>
      )}
      {showDeleteUserSuperAdminModal && (
        <DeleteUserSuperAdminModal
          isOpen={showDeleteUserSuperAdminModal}
          switchModal={switchSuperAdminDelete}
          user={user}
          fetchData={fetchData}
        />
      )}
      <StartPreviewModal
        callback={handlePreview}
        switchModal={switchStartPreviewModal}
        isOpen={showStartPreviewModal}
        user={user}
        handleQuickResolvedIssue={handleQuickResolvedIssue}
      />
      <EditUserModal fetchData={fetchData} switchModal={switchEditModal} isOpen={showEditModal} user={user} />
    </div>
  );
};
